import {Component, inject} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Feedback} from '../../classes/feedback';
import {HelpService} from '../../services/help.service';
import {BaseModal} from '../../../../classes/base-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';

type FeedbackType = 'bug' | 'feature' | 'feedback' | 'training';

@Component({
    selector: 'eaglei-user-feedback',
    templateUrl: './user-feedback.component.html',
    styleUrls: ['./user-feedback.component.scss'],
    standalone: false,
})
export class UserFeedbackComponent extends BaseModal {
    private helpService = inject(HelpService);
    private popup = inject(MatSnackBar);

    protected feedbackForm = new FormGroup({
        feedbackType: new FormControl<FeedbackType>(null, {validators: Validators.required}),
        description: new FormControl<string>(null, {validators: Validators.required}),
        summary: new FormControl<string>(null, {validators: Validators.required}),
    });

    // For some eccentric reason, the injection on this throws an error
    constructor(public dialogRef: MatDialogRef<UserFeedbackComponent>) {
        super();
    }

    public submitFeedback(): void {
        const formValue = this.feedbackForm.getRawValue();
        const feedback = new Feedback({
            feedbackType: formValue.feedbackType,
            summary: formValue.summary,
            description: formValue.description,
            trainingRequested: formValue.feedbackType === 'training',
        });

        this.helpService.submitUserFeedback(feedback).subscribe({
            next: () => {
                this.popup.open('Feedback Submitted', 'Close', {duration: 5000, panelClass: ['success']});
                this.dialogRef.close();
            },
            error: (e) => {
                console.error('Error in feedback submission', e);
                this.popup.open('Feedback Submission Failed', 'Close', {panelClass: ['failure']});
            },
        });
    }

    afterInit() {}
}
